import { render, staticRenderFns } from "./SelectEcomProduct.vue?vue&type=template&id=1f048510&scoped=true"
import script from "./SelectEcomProduct.vue?vue&type=script&lang=js"
export * from "./SelectEcomProduct.vue?vue&type=script&lang=js"
import style0 from "./SelectEcomProduct.vue?vue&type=style&index=0&id=1f048510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f048510",
  null
  
)

export default component.exports